import React from 'react';

const CellCenter = ({value}) => {
    return (
        <span className="m-auto">{value}</span>
    );
};

export default CellCenter;